import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { LoginComponent } from './login/login.component';
import { GeneralquestionsComponent } from './generalquestions/generalquestions.component';
// import { AuthGuard } from './auth.guard';

// const routes: Routes = [
//   { path: '', redirectTo: '/login', pathMatch: 'full' },
//   { path: 'login', component: LoginComponent },
//   { 
//     path: 'general-questions', 
//     component: GeneralquestionsComponent, 
//     canActivate: [AuthGuard] 
//   },
//   {
//     path: 'dashboard',
//     redirectTo: '/general-questions', 
//     pathMatch: 'full'
//   }
// ];

export const routes: Routes = [
  { path: '', redirectTo: '/general-questions', pathMatch: 'full' },
  { path: 'general-questions', component: GeneralquestionsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
